export default function () {

    const sanitizeHtml = useUtilitySanitize().sanitizeHtml;

    function buildReactiveHead (course, error) {
        watch(course, () => {buildHead(course.value, error.value);}, {immediate: true});
    }

    function buildHead(course, error) {
        if (course === null && !error) return useSeo().buildHeadLoading();
        if (!course) return useSeo().buildHeadNotFound();
        return useSeo().buildHead({
            image: course.course_image_url || null,
            title: course.course_title,
            description: sanitizeHtml(course.course_excerpt) || 'View details of this course on the Andy Guitar website.',
            index: true,
            structuredData: useSchemaCourse().build(course)
        });
    }

    return {buildReactiveHead};
};
